// extracted by mini-css-extract-plugin
export var addressFields = "_o4-0";
export var animationContainer = "_o4-1";
export var footer = "_o4-2";
export var lineItems = "_o4-3";
export var modalContent = "_o4-4";
export var orderName = "_o4-5";
export var strong = "_o4-6";
export var warning = "_o4-7";